import React from 'react';
import { MenuItems, TabButtons } from '../../../healtheraComponents';
import { TabChangeHandler, TabNavbarV2Props } from './types';
import { Tab } from '@material-ui/core';

const TabNavbarV2 = ({ currentTab, tabs, onChange }: TabNavbarV2Props) => {
  const handleTabChange: TabChangeHandler = (_, tab) => {
    onChange(tab);
  };

  return (
    <MenuItems>
      <TabButtons value={currentTab} onChange={handleTabChange} fontSize="16px">
        {tabs.map(tab => (
          <Tab label={tab.label} key={tab.label} />
        ))}
      </TabButtons>
    </MenuItems>
  );
};

export default TabNavbarV2;
